import React from 'react';
import { Button } from 'react-bootstrap';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';
import './filters.scss';

interface AppliedFilterProps {
  name: string,
  onClick: () => void
}

export default function AppliedFilter({
  name,
  onClick,
}: AppliedFilterProps) {
  return (
    <Button
      className="applied-filter-button text-white me-2 mb-5 mt-2"
      variant="secondary"
      size="sm"
      onClick={onClick}
    >
      <Icon
        iconType="close"
        className="pe-2"
        color={cssVar('text-on-accent')}
      />
      {name}
    </Button>
  );
}
